const BlueBoxSuggestion = function(){
	const common = new bbCommon();
	let omniture; // call this later for race condition purposes
	const bbModel = common.bbModel;
	const submitSuggestionBtn = document.getElementById('submitSuggestion');
	
	const send = (e) =>{
		// set this later to create enough time to prevent a racing condition
		if (!omniture) {
			omniture = common.OmnitureLogBtn();
		}
		
		omniture.BtnPushed("submitSuggestion"); 
		
		const bbSuggestion = document.getElementById('bbSuggestion');
		const suggestionError = document.getElementById('suggestionError');
		if (bbSuggestion.value == "") {
           	 	bbSuggestion.classList.add("input-validation-error");
            		bbSuggestion.setAttribute("aria-invalid", "true");
            		suggestionError.classList.remove("hide");
            		bbSuggestion.focus();
        	}else {
            		bbSuggestion.classList.remove("input-validation-error");
            		bbSuggestion.setAttribute("aria-invalid", "false");
            		suggestionError.classList.add("hide");
            		suggestBB();
        	}
	};
	
	const cancel = () =>{
		document.getElementById("boxSuggestion").classList.add("hide");
        	common.ResetInvalidFields();
		const altBoxOptions = document.getElementById("altBoxOptions");
		if (altBoxOptions) {
			altBoxOptions.classList.remove("opaque");
			document.getElementById("altBoxButtons").classList.remove("hide");
			var altBoxRadioButtons = document.getElementsByClassName("altBoxRadio");
			if (altBoxRadioButtons) {
				for (let i = 0; i < altBoxRadioButtons.length; i++) {
					altBoxRadioButtons[i].disabled = false;
				}
				document.getElementById("requestCustomBox").focus();
			}
		}else {
			document.getElementById("bbProducts").classList.remove("opaque");
	        	document.getElementById("blueBoxButtons").classList.remove("hide");
	        	document.getElementById("otherBox").focus();
        	}
	};
	
	const suggestBB = async () =>{
		const suggestionLoading = document.getElementById("submittingSuggestion");
		suggestionLoading.classList.remove("hide");
		common.DisableBlueBtn(submitSuggestionBtn);
		common.RemoveStatusMsg();
		
		const campaignID = document.getElementById("CampaignID");
		const contactID = document.getElementById("CustomerContactID");
		const customerID = document.getElementById("CustomerID");
		const bbSuggestion = document.getElementById("bbSuggestion");
		
		bbModel.CampaignID = campaignID ? campaignID.value : "";
		bbModel.CustomerContactID = contactID ? contactID.value : "";
		bbModel.CustomerID = customerID ? customerID.value : "";
		bbModel.Suggestion = bbSuggestion ? bbSuggestion.value : "";
		
		const altBoxSeen = document.getElementById("AltBoxesSeen");
		bbModel.AltBoxesSeen = altBoxSeen ? altBoxSeen.value : "false";
		if (bbModel.AltBoxesSeen == "true") common.GetAltBoxIDs();
		common.FixBoxModel(bbModel);
		let responseJSON;
		try{
			const response = await fetch('/bluebox/BoxSuggestion', { 
	        		method: 'POST', 
	        		credentials: 'same-origin',
	        		body: JSON.stringify(bbModel), 
	        		headers: { 
	        			'Content-Type': 'application/json', 
	        			'X-Requested-With': 'fetch',
	        			'RequestVerificationToken': common.HeaderToken,
	        			'__RequestVerificationToken': common.HeaderToken
	        		}
			});
			
			//if (!response.ok) throw new Error('Error processing bluebox suggestion request');
    			responseJSON = await response.json();
		}catch(error){
			suggestionFail(suggestionLoading);
			console.log(error);
		}
		
		if(responseJSON) suggestionSuccess(responseJSON);
	};
	
	const suggestionFail = (loading) =>{
		loading.classList.add("hide");
		common.DisplayStatusMsg();
		common.EnableBlueBtn(submitSuggestionBtn);
	};
	
	const suggestionSuccess = (response) => {
		common.DisplayFormSections(response);
		common.EnableBlueBtn(submitSuggestionBtn);
	};
	
	return{
		Send: send, 
		Cancel: cancel
	};
};